import styles from "./Section.module.scss";
import React, {ReactNode, useEffect, useRef} from "react";

interface SectionProps {
    children: ReactNode,
    className?: string,
    id: string
}

const Section: React.FC<SectionProps> = ({children, className, id}) => {
    const sectionRef = useRef<HTMLElement>(null);

   // if the section is visible, then set location url to #id
    useEffect(() => {
        const handleSectionVisibility = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                console.log(id);
                if (entry.isIntersecting) {
                    window.history.pushState({}, '', `#${id}`);
                }
            });
        };

        const observer = new IntersectionObserver(handleSectionVisibility, {
            root: null,
            threshold: 0,
            rootMargin: '-50% 0px -50% 0px',
        });

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, [id]);


    return (
        <section className={styles.main} id={id} ref={sectionRef}>
            <div className={styles.content + ' ' + className}>
                {children}
            </div>
        </section>
    )
};
export default Section;